import { h } from "preact";
import Steps from "./Steps";
import EditEvent from "./EditEvent";
import { Link } from "preact-router/match";
import { connect } from "react-redux";
import { css } from "emotion";

const BookingHeader = ({
  event,
  order,
  includeSeatingMap,
  merchandise,
  isGlobal,
  eventDate
}) => {
  const style = {
    textAlign: "center",
    paddingTop: 16,
    paddingLeft: 14,
    paddingRight: 14,
    borderBottom: isGlobal ? "none" : "1px solid #dedede",
    h1: {
      fontSize: 20,
      margin: 0,
      marginBottom: 4
    }
  };
  if (isGlobal) {
    return <div style={style} />;
  }
  const { includesMerch } = merchandise;
  const link = event
    ? event.widget
      ? `/${event.data.slug}/tickets`
      : `/${event.data.slug}`
    : "";
  const orderId = order && order.data ? order.data._id : null;
  const isConference = event.data.settings.enableTicketAssigning;
  const compiledStyle = css(style);
  return (
    <div className={compiledStyle}>
      <EditEvent event={event.data} />
      <h1>
        <Link href={link} style={{ color: "#323232" }}>
          {event.data.name}
        </Link>
      </h1>
      {eventDate && eventDate.combined ? (
        <p style={{ marginBottom: 8 }}>{eventDate.combined}</p>
      ) : null}
      <Steps
        eventSlug={event.data.slug}
        theme={event.data.theme}
        orderId={orderId}
        includeSeatingMap={includeSeatingMap}
        includesMerch={includesMerch}
        isConference={isConference}
      />
    </div>
  );
};

export default connect(
  state => ({
    event: state.event,
    order: state.order,
    merchandise: state.merchandise,
    eventDate: state.ticketSelection.selectedDateDisplay
  }),
  {}
)(BookingHeader);



// WEBPACK FOOTER //
// ./components/BookingHeader.js